import React, {ReactElement} from 'react';
import {FormattedMessage} from 'react-intl';

import GetStarted, {GetStartedButtonProps} from '../Buttons/GetStarted/GetStarted';
import Checkpoints from '../../Homepage/Checkpoints/Checkpoints';
import Headers, {HeaderType} from '../Text/Headers/Headers';
import Paragraph from '../Text/Paragraph/Paragraph';
import {Alignment} from '../../../types';

import './LookingForFinance.scss';

export enum LookingForFinanceSize {
  LG = 'large',
  SM = 'small',
}

interface Props {
  title?: string;
  text?: string;
  buttonProps?: GetStartedButtonProps;
  hideCheckpoints?: boolean;
  size: LookingForFinanceSize;
}

function LookingForFinance({title, text, buttonProps, hideCheckpoints, size}: Props): ReactElement {
  const lookingForFinanceTitle = title || <FormattedMessage id="homepage.lookingForFinance.title" />;
  const lookingForFinanceText = text || <FormattedMessage id="homepage.lookingForFinance.text" />;
  const headerType = size === 'large' ? HeaderType.H2 : HeaderType.H4;

  return (
    <div className={`lookingForFinance ${`lookingForFinance--${size}`}`}>
      <div className="lookingForFinance__wrapper">
        <div
          className={`lookingForFinance__titleWrapper ${
            !hideCheckpoints && 'lookingForFinance__titleWrapper--showCheckpoints'
          }`.trim()}
        >
          <Headers headerType={headerType} alignment={Alignment.LEFT} className="lookingForFinance__title">
            {lookingForFinanceTitle}
          </Headers>
          <Paragraph className="lookingForFinance__subtitle" alignment={Alignment.LEFT}>
            {lookingForFinanceText}
          </Paragraph>
          <GetStarted buttonText={buttonProps && buttonProps.buttonText} url={buttonProps && buttonProps.url} />
        </div>
        {!hideCheckpoints && (
          <div className="lookingForFinance__content">
            <Checkpoints />
          </div>
        )}
      </div>
    </div>
  );
}

export default LookingForFinance;
